module.exports = __webpack_public_path__ + "img/error.3ab8ad57.svg";